import {Component, HostBinding} from '@angular/core';
import {I18nKeyEnum} from '../shared/models/language.model';
import {FormControl, FormGroup} from '@angular/forms';
import {Country} from '../shared/models/countries.model';
import {combineLatest} from 'rxjs';
import {CountryService} from '../shared/services/country.service';
import {ValidatorsErrorEnum} from '../shared/models/form.model';
import {ValidatorService} from '../shared/services/validator.service';

@Component({
    selector: 'app-free-trial',
    standalone: false,
    templateUrl: './free-trial.component.html',
    styleUrl: './free-trial.component.scss'
})
export class FreeTrialComponent {
    protected readonly I18nKeyEnum = I18nKeyEnum;
    @HostBinding('class.callback-dialog') default = true;
    public freeTrialForm: FormGroup;
    public nameCtrl: FormControl<string>;
    public nationalNumberCtrl: FormControl<string>;
    public countryPrefixCtrl: FormControl<Country>;
    public readonly validatorsErrorEnum = ValidatorsErrorEnum;
    public countries: Country[] = [];
    
    constructor(private countryService: CountryService,
                private validatorService: ValidatorService) {
        
        this.nameCtrl = new FormControl();
        this.nationalNumberCtrl = new FormControl();
        this.countryPrefixCtrl = new FormControl();
        
        this.freeTrialForm = new FormGroup({
            name: this.nameCtrl,
            countryPrefix: this.countryPrefixCtrl,
            nationalNumber: this.nationalNumberCtrl,
        });
        
        combineLatest([
            this.countryService.preSelectedCountry$,
            this.countryService.countries$]).subscribe(data => {
            this.countryPrefixCtrl.setValue(data[0]);
            this.countries = data[1];
        });
    }
    
    validatePhoneNumber() {
        if (!!this.countryPrefixCtrl.value?.countryPrefix && (!!this.nationalNumberCtrl.value && this.nationalNumberCtrl.value.length > 0)) {
            if (this.validatorService.checkValidNumber(this.countryPrefixCtrl.value.countryPrefix, this.nationalNumberCtrl.value)) {
                this.nationalNumberCtrl.setErrors(null);
                const formattedNumber = this.validatorService.getNationalNumber(this.countryPrefixCtrl.value.countryPrefix, this.nationalNumberCtrl.value);
                if (!!formattedNumber && this.nationalNumberCtrl.value !== formattedNumber) {
                    this.nationalNumberCtrl.setValue(formattedNumber);
                }
            } else {
                this.nationalNumberCtrl.setErrors({[this.validatorsErrorEnum.INVALID_NUMBER]: true});
            }
        }
    }
}
